import { combineReducers } from 'redux';
import updateName from './updateName'
import updatePassword from './updatePassword'
import userDetails from './userDetails'
export default combineReducers({
    updateName,
    updatePassword,
    userDetails
});